import * as angular from 'angular';
import {IController} from "angular";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {AccountModel} from "../../../account/angular/models/account.model";
import * as _ from "lodash";
import {AccountsService} from "../../../account/services/accounts-service.service";

export class EditContractAccountsDialogViewComponent implements IController {

  initialAccountIds: string[];
  onAccountListsChanged: Function;

  public queryString: string = '';

  public allAccounts: AccountModel[];
  public initialAccounts: AccountModel[];
  public accountsOnContract: AccountModel[];
  public accountsNotOnContract: AccountModel[];
  private accountsRef: any;
  private readonly loadLimit: number = 20;

  constructor(private $accounts: $accountsFactory, private accountsService: AccountsService) {
  }

  $onInit() {

    this.accountsRef = this.$accounts();

    // this.accountsRef.$getAll(this._getQuery())
    //   .then((accountIds) => {
    //     return this.accountsRef.$asyncValues(accountIds)
    //   })
    //   .then((allAccounts: AccountModel[]) => {
    //     this.allAccounts = allAccounts || [];
    //     this.initialAccounts = allAccounts?.filter(ac => this.initialAccountIds.includes(ac.id)) || []
    //     this.accountsOnContract = this.initialAccounts
    //     this.accountsNotOnContract = allAccounts.filter(ac => !this.accountsOnContract.includes(ac))
    //   })

    this.accountsService.getAll(this._getQuery())
      .then((allAccounts: AccountModel[]) => {
        this.allAccounts = allAccounts || [];
        this.initialAccounts = allAccounts?.filter(ac => this.initialAccountIds.includes(ac.id)) || []
        this.accountsOnContract = this.initialAccounts
        this.accountsNotOnContract = allAccounts.filter(ac => !this.accountsOnContract.includes(ac))
      })

  }

  submitQuery(query) {
    this.queryString = query;
  }

  onAddAccountClick(accounts: AccountModel[]) {
    this.accountsNotOnContract = this.accountsNotOnContract.filter(aoc => !accounts.includes(aoc));
    this.accountsOnContract.unshift(...accounts)

    this._accountsChanged()
  }

  onRemoveAccountClick(accounts: AccountModel[]) {
    this.accountsOnContract = this.accountsOnContract.filter(aoc => !accounts.includes(aoc));
    this.accountsNotOnContract.unshift(...accounts)

    this._accountsChanged()
  }

  private _accountsChanged() {

    this.onAccountListsChanged({
      accountIdsToAdd: this.accountsOnContract.filter(a => !this.initialAccountIds.includes(a.id)).map(a => a.id),
      accountIdsToRemove: this.accountsNotOnContract.filter(a => this.initialAccountIds.includes(a.id)).map(a => a.id),
    });
  }

  private _getQuery() {
    return {
      limit: 1000,
      query: this.queryString,
      isSupply: true,
    };
  }

}

angular
  .module(
    'bringoz.admin.contracts'
  )
  .component('editContractAccountsDialogView', {
      bindings: {
        initialAccountIds: '<?',
        onAccountListsChanged: '&'
      },
      template: require('./edit-contract-accounts-dialog-view.html').default,
      controller: EditContractAccountsDialogViewComponent
    }
  );
